import { useEffect } from "react";
import { logger, normalizeDropdownOptionsData } from "@/utils";
import { map } from "lodash";
import { useRequestState } from "@/hooks";
import { DEFAULT_DROPDOWN_NONE_VALUE } from "@/constants";
import { requestSubcontractorsList, SubContractor } from "@/services/api";

export const useSubContractors = (email: string) => {
  const { data, error, setError, isLoading, setInProgress, setSuccess } =
    useRequestState<SubContractor[]>();

  useEffect(() => {
    const controller = new AbortController();

    requestSubcontractorsList(
      { email },
      {
        signal: controller.signal,
      },
    )
      .then(response =>
        setSuccess(normalizeDropdownOptionsData(response, "CompanyNameEn")),
      )
      .catch(error => {
        setError(error.message);

        logger.error(error);
      });

    return () => {
      controller.abort();
    };
  }, [email, setError, setInProgress, setSuccess]);

  return {
    isLoading,
    subContractors: [
      DEFAULT_DROPDOWN_NONE_VALUE,
      ...map(data, subContractor => {
        return {
          ...subContractor,
          Id: subContractor.SubContractorId,
        };
      }),
    ],
    error,
  };
};
